import { CSSProperties } from "react";
import { theme } from "antd";

export function TreemapIcon(props: {
  style?: CSSProperties;
  size?: number;
  inactive?: boolean;
}) {
  const { token } = theme.useToken();
  const size = props.size === undefined ? 16 : props.size;
  if (size <= 20)
    return <Small style={props.style} inactive={props.inactive} />;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9" clipPath="url(#clip0_6375_128143)">
        <g clipPath="url(#clip1_6375_128143)">
          <rect
            width="20"
            height="12"
            transform="translate(-0.621094 -0.625)"
            fill={token.colorText}
          />
          <rect
            width="20"
            height="8"
            transform="translate(-0.621094 12.375)"
            fill={token.colorText}
          />
        </g>
        <g clipPath="url(#clip2_6375_128143)">
          <rect
            width="10"
            height="16"
            transform="translate(10.3789 -0.625)"
            fill={token.colorText}
          />
        </g>
        <g clipPath="url(#clip3_6375_128143)">
          <rect
            width="6"
            height="14"
            transform="translate(10.3789 9.375)"
            fill={token.colorText}
          />
          <rect
            width="4"
            height="14"
            transform="translate(17.3789 9.375)"
            fill={token.colorText}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6375_128143">
          <rect width="20" height="15" fill="white" />
        </clipPath>
        <clipPath id="clip1_6375_128143">
          <rect
            width="10"
            height="22"
            fill="white"
            transform="translate(-0.621094 -0.625)"
          />
        </clipPath>
        <clipPath id="clip2_6375_128143">
          <rect
            width="10"
            height="9"
            fill="white"
            transform="translate(10.3789 -0.625)"
          />
        </clipPath>
        <clipPath id="clip3_6375_128143">
          <rect
            width="11"
            height="6"
            fill="white"
            transform="translate(10.3789 9.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function Small(props: { style?: CSSProperties; inactive?: boolean }) {
  const { token } = theme.useToken();
  if (props.inactive) return <Inactive style={props.style} />;
  return (
    <svg
      style={props.style}
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9" clipPath="url(#clip0_6375_128143)">
        <g clipPath="url(#clip1_6375_128143)">
          <rect
            width="20"
            height="12"
            transform="translate(-0.621094 -0.625)"
            fill={token.colorText}
          />
          <rect
            width="20"
            height="8"
            transform="translate(-0.621094 12.375)"
            fill={token.colorText}
          />
        </g>
        <g clipPath="url(#clip2_6375_128143)">
          <rect
            width="10"
            height="16"
            transform="translate(10.3789 -0.625)"
            fill={token.colorText}
          />
        </g>
        <g clipPath="url(#clip3_6375_128143)">
          <rect
            width="6"
            height="14"
            transform="translate(10.3789 9.375)"
            fill={token.colorText}
          />
          <rect
            width="4"
            height="14"
            transform="translate(17.3789 9.375)"
            fill={token.colorText}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6375_128143">
          <rect width="20" height="15" fill="white" />
        </clipPath>
        <clipPath id="clip1_6375_128143">
          <rect
            width="10"
            height="22"
            fill="white"
            transform="translate(-0.621094 -0.625)"
          />
        </clipPath>
        <clipPath id="clip2_6375_128143">
          <rect
            width="10"
            height="9"
            fill="white"
            transform="translate(10.3789 -0.625)"
          />
        </clipPath>
        <clipPath id="clip3_6375_128143">
          <rect
            width="11"
            height="6"
            fill="white"
            transform="translate(10.3789 9.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function Inactive(props: { style?: CSSProperties }) {
  const { token } = theme.useToken();
  return (
    <svg
      style={props.style}
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" clipPath="url(#clip0_6375_128143)">
        <g clipPath="url(#clip1_6375_128143)">
          <rect
            width="20"
            height="12"
            transform="translate(-0.621094 -0.625)"
            fill={token.colorTextTertiary}
          />
          <rect
            width="20"
            height="8"
            transform="translate(-0.621094 12.375)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g clipPath="url(#clip2_6375_128143)">
          <rect
            width="10"
            height="16"
            transform="translate(10.3789 -0.625)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g clipPath="url(#clip3_6375_128143)">
          <rect
            width="6"
            height="14"
            transform="translate(10.3789 9.375)"
            fill={token.colorTextTertiary}
          />
          <rect
            width="4"
            height="14"
            transform="translate(17.3789 9.375)"
            fill={token.colorTextTertiary}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6375_128143">
          <rect width="20" height="15" fill="white" />
        </clipPath>
        <clipPath id="clip1_6375_128143">
          <rect
            width="10"
            height="22"
            fill="white"
            transform="translate(-0.621094 -0.625)"
          />
        </clipPath>
        <clipPath id="clip2_6375_128143">
          <rect
            width="10"
            height="9"
            fill="white"
            transform="translate(10.3789 -0.625)"
          />
        </clipPath>
        <clipPath id="clip3_6375_128143">
          <rect
            width="11"
            height="6"
            fill="white"
            transform="translate(10.3789 9.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
